export enum TripDateRuleDayOfWeek {
  Sunday = 1,
  Monday = 2,
  Tuesday = 3,
  Wednesday = 4,
  Thursday = 5,
  Friday = 6,
  Saturday = 7
}

/** Mirrors `TripAccommodations` in ppmapi-loopback `shared/src/trips/accommodations.ts`. A blank value means NotSpecified. */
export const TripAccommodations = {
  NotSpecified: "Not specified",
  Bunk: "Bunk",
  Floor: "Floor",
  Hotel: "Hotel",
  Other: "Other",
} as const;
export type TripAccommodations = typeof TripAccommodations[keyof typeof TripAccommodations];



export type TripDateRuleTypes = "YW Offseason" | "YW Referral" | "EPC" | "Cartel" | "Disaster" | "FMSC" | "Small" | "Vision" | "Leader" | "Standard" | "No Regi Fee"

export interface AddTripDateRuleReturn {
  rule: TripDateOpenRule
  reportRow: TripDateOpenRuleReportItem
}

export interface AddTripDateClosedRuleReturn {
  rule: TripDateClosedRule
  reportRow: TripDateClosedRuleReportItem
}

export interface EditTripDateRuleReturn extends AddTripDateRuleReturn {
}

export interface EditTripDateClosedRuleReturn extends AddTripDateClosedRuleReturn {
}

export interface TripDateOpenRule {
  id: number,
  locId: string,
  airportId: number,
  staffId: number,
  startDate: Date,
  endDate: Date,
  duration: number,
  cost: number,
  accommodations?: string | null,
  cartel: number,
  disaster: number,
  fmsc: number,
  smallGroup: number,
  vision: number,
  leader: number,
  leaderMission: number,
  leaderSponsor: number,
  epc: number,
  youthworks: number,
  ywOffseason: number,
  ywReferral: number,
  waiveRegiFee: number,
  cutoff: number,
  dayOfWeek: TripDateRuleDayOfWeek,
  minAttendees: number,
  note?: string,
  active: number,
  officeId: number,
  hideDatesPage: number

}

export interface TripDateOpenRuleReportItem {
  id: number;
  officeName: string;
  locationName: string;
  region: string;
  aircode: string;
  staffId: number;
  staffName: string;
  locId: string;
  startDate: Date;
  endDate: Date;
  duration: number;
  cost: number;
  cartel: number;
  disaster: number;
  fmsc: number;
  smallGroup: number;
  vision: number;
  leader: number;
  leaderMission: number;
  leaderSponsor: number;
  epc: number;
  ywOffseason: number;
  ywReferral: number;
  waiveRegiFee: number;
  cutoff: number;
  dayOfWeekFormatted: string;
  dayOfWeek: TripDateRuleDayOfWeek;
  minAttendees: number;
  note: string;
  types: TripDateRuleTypes[];
}

export interface TripDateClosedRule {
  id: number,
  locId: string,
  staffId: number,
  startDate: Date,
  endDate: Date,
  cost: number,
  cartel: number,
  disaster: number,
  fmsc: number,
  smallGroup: number,
  vision: number,
  leader: number,
  leaderMission: number,
  leaderSponsor: number,
  epc: number,
  youthworks: number,
  ywOffseason: number,
  ywReferral: number,
  disableWebleadForm: number,
  dayOfWeek: TripDateRuleDayOfWeek,
  note?: string,
  active: number,
  officeId: number
}

export interface TripDateClosedRuleReportItem {
  id: number;
  officeName: string;
  locationName: string;
  region: string;
  staffName: string;
  staffId: number;
  locId: string;
  startDate: Date;
  endDate: Date;
  cost: number;
  cartel: number;
  disaster: number;
  fmsc: number;
  smallGroup: number;
  vision: number;
  leader: number;
  leaderMission: number;
  leaderSponsor: number;
  epc: number;
  ywOffseason: number;
  ywReferral: number;
  disableWebleadForm: number;
  dayOfWeekFormatted: string;
  dayOfWeek: number;
  note: string
  types: TripDateRuleTypes[];
}


export interface TripDatesOpenReportItem {

  id: number;
  officeName: string;
  locationName: string;
  region: string;
  aircode: string;
  locId: string;
  tripDate: Date;
  duration: number;
  cost: number;
  cartel: number;
  disaster: number;
  fmsc: number;
  smallGroup: number;
  vision: number;
  leader: number;
  leaderMission: number;
  leaderSponsor: number;
  epc: number;
  ywOffseason: number;
  ywReferral: number;
  waiveRegiFee: number;
  minAttendees: number;
  types: TripDateRuleTypes[];
  hash: string;

}

export const RolloverSelectionModes = {
  FullYearFlagFreeActive: "fullYearFlagFreeActive",
} as const;
export type RolloverSelectionMode = typeof RolloverSelectionModes[keyof typeof RolloverSelectionModes];

export const RolloverExclusionReasons = {
  Inactive: "inactive",
  NotFullCalendarYear: "notFullCalendarYear",
  HasTripTypeFlags: "hasTripTypeFlags",
} as const;
export type RolloverExclusionReason = typeof RolloverExclusionReasons[keyof typeof RolloverExclusionReasons];

export const rolloverTripTypeFlags = [
  "cartel",
  "disaster",
  "fmsc",
  "smallGroup",
  "vision",
  "leader",
  "leaderMission",
  "leaderSponsor",
  "epc",
  "youthworks",
  "ywOffseason",
  "ywReferral",
] as const;
export type RolloverTripTypeFlag = typeof rolloverTripTypeFlags[number];

export interface RolloverPreviewRule {
  id: number;
  locId: string;
  locationName: string;
  aircode: string;
  duration: number;
  cost: number;
  accommodations: string;
  dayOfWeek: number;
  dayOfWeekFormatted: string;
  projectedOpenDateCount: number;
}

export interface RolloverExcludedPreviewRule extends RolloverPreviewRule {
  startDate: string;
  endDate: string;
  tripTypeFlags: RolloverTripTypeFlag[];
  exclusionReasons: RolloverExclusionReason[];
}

export interface RolloverPreview {
  rules: RolloverPreviewRule[];
  excludedRules: RolloverExcludedPreviewRule[];
  targetYearHasActiveFullYearOpenRules: boolean;
  projectedOpenDateCount: number;
}

export interface RolloverCommitRequest {
  sourceRuleIds: number[];
  targetYear: number;
  selectionMode: RolloverSelectionMode;
  note?: string;
}

export interface RolloverCommitResult {
  rulesCreated: number;
  rulesSkipped: number;
}

export interface TripDatesOpen {
  id: number;
  hash: string;
  ruleId: number;
  tripDate: Date;
  locId: string;
  airportId: number;
  duration: number;
  cost: number;
  cartel: number;
  disaster: number;
  fmsc: number;
  smallGroup: number;
  vision: number;
  leader: number;
  leaderMission: number;
  leaderSponsor: number;
  epc: number;
  youthworks: number;
  ywOffseason: number;
  ywReferral: number;
  waiveRegiFee: number;
  minAttendees: number;
  officeId: number;
  hideDatesPage: number;
  limitedAvailability: number;
}
